import { render, staticRenderFns } from "./TimelabSlider.vue?vue&type=template&id=66f8e2d9&scoped=true"
import script from "./TimelabSlider.vue?vue&type=script&lang=js"
export * from "./TimelabSlider.vue?vue&type=script&lang=js"
import style0 from "./TimelabSlider.vue?vue&type=style&index=0&id=66f8e2d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f8e2d9",
  null
  
)

export default component.exports